<!-- src/app/sidebar/sidebar.component.html -->
<div class="sidebar">
  <div class="app-logo" routerLink="/dashboard" style="cursor:pointer;">
    <img src="assets/dgc_logo.png" alt="App Logo">
  </div>
  
  <div class="nav-items">
    <div *ngFor="let item of navItems; let i = index" 
         [ngClass]="{'sideactive': item.active}"
         class="nav-item"
         (click)="toggleActive(i)" 
         [routerLink]="item.link">
      <div class="icon-container" style="position: relative;">
        <i class="bi bi-{{item.icon}}"></i>
        <!-- Unread badge only on Notifications item -->
        <!-- <span *ngIf="item.name === 'Notifications' && unreadCount > 0" class="sidebar-notif-badge">
          {{ unreadCount > 99 ? '99+' : unreadCount }}
        </span> -->
      </div>
      <span class="item-name">{{item.name}}</span>
    </div>
  </div>
</div>